import {asset} from "../helpers/assets";
import Vue from 'vue'

Vue.mixin({
    methods: {
        asset: (resource, secure = true) => asset(resource, secure)
    }
});